import React, { useState, useEffect } from "react";
import Screen from "../shared/screen";
import { axiosInstance } from "../../config/apiTemplate";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";

function MRClientSelectPage() {
    const [clients, setClients] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [search, setSearch] = useState("");
    const [isLoading, setLoading] = useState(true);
    const [isSwitching, setIsSwitching] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        document.title = "ETSW - View as Client";
        fetchClients();
    }, []);

    useEffect(() => {
        const q = search.toLowerCase();
        setFiltered(
            clients.filter(c =>
                (c.name  || "").toLowerCase().includes(q) ||
                (c.email || "").toLowerCase().includes(q) ||
                (c.client_code || "").toLowerCase().includes(q)
            )
        );
    }, [search, clients]);

    async function fetchClients() {
        setLoading(true);
        setError("");
        try {
            const response = await axiosInstance.post("client_api/account/getMRClients.php", new FormData());
            if (response.data.status === 201) {
                setClients(response.data.clients || []);
            } else {
                setError(response.data.message || "Failed to load clients.");
            }
        } catch (e) {
            console.log(e);
            setError("Something went wrong. Please try again.");
        }
        setLoading(false);
    }

    async function switchToClient(client) {
        setIsSwitching(true);
        try {
            let form = new FormData();
            form.append("target_member_id", client.member_id);

            const response = await axiosInstance.post("client_api/account/viewAsClient.php", form);
            if (response.data.status === 201) {
                // Save current MR session so we can restore it later
                localStorage.setItem("mr_token",       localStorage.getItem("token"));
                localStorage.setItem("mr_rt",          localStorage.getItem("rt"));
                localStorage.setItem("mr_t_id",        localStorage.getItem("t_id"));
                localStorage.setItem("mr_clientCode",  localStorage.getItem("clientCode"));
                localStorage.setItem("mr_name",        localStorage.getItem("name"));
                localStorage.setItem("mr_email",       localStorage.getItem("email"));
                localStorage.setItem("mr_productView", localStorage.getItem("productView"));

                // Switch to the client's session
                localStorage.setItem("token",       response.data.token);
                localStorage.setItem("rt",          response.data.refresh_token);
                localStorage.setItem("t_id",        response.data.member_data.trading_ac_id);
                localStorage.setItem("clientCode",  response.data.member_data.client_code);
                localStorage.setItem("name",        response.data.member_data.firstname);
                localStorage.setItem("email",       response.data.member_data.email);
                localStorage.setItem("hasSavings",  response.data.hasSavings);
                localStorage.setItem("isViewingAsClient", "true");

                // Set productView the same way login does
                if (response.data.hasSavings === true) {
                    localStorage.setItem("productView", "Aggregated");
                } else if (response.data.availableProducts && response.data.availableProducts.length > 0) {
                    localStorage.setItem("productView", response.data.availableProducts[0]);
                }

                const productView = localStorage.getItem("productView");
                if (productView === "Aggregated" || productView === "Savings MM") {
                    window.location.href = "/aggregated?v=1";
                } else {
                    window.location.href = "/dashboard?v=1";
                }
            } else {
                window.alert(response.data.message || "Failed to switch client.");
                setIsSwitching(false);
            }
        } catch (e) {
            console.log(e);
            window.alert("Something went wrong. Please try again.");
            setIsSwitching(false);
        }
    }

    function renderClients() {
        if (filtered.length === 0) {
            return (
                <div className="text-center text-muted py-4">
                    No clients found.
                </div>
            );
        }

        return filtered.map((client, index) => (
            <div
                key={index}
                className="d-flex align-items-center justify-content-between py-2 px-1"
                style={{ borderBottom: "1px solid #f0f0f0" }}
            >
                <div>
                    <div style={{ fontWeight: 600 }}>{client.name}</div>
                    <div style={{ fontSize: 13, color: "#888" }}>{client.email}</div>
                    <div style={{ fontSize: 13, color: "#555", marginTop: 2 }}>
                        AUM: <strong>RM {Number(client.total_aum).toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                        {" · "}
                        {client.total_portfolios} {client.total_portfolios === 1 ? "portfolio" : "portfolios"}
                    </div>
                </div>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    disabled={isSwitching}
                    onClick={() => switchToClient(client)}
                >
                    {isSwitching ? "Switching…" : "View"}
                </Button>
            </div>
        ));
    }

    return (
        <div>
            <Screen origin="account">
                <div className="container pt-4">
                    <div className="row">
                        <div className="col">
                            <div className="container-fluid">
                                <div className="statusCardHeader row align-items-center justify-content-between">
                                    <div className="col">
                                        <h6 className="statusCardHeaderTitle">SELECT CLIENT TO VIEW AS</h6>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col bg-white" style={{ marginLeft: 15, marginRight: 15 }}>
                                        <br />

                                        {isLoading && (
                                            <div className="text-center py-4">
                                                <CircularProgress />
                                                <p className="mt-2">Loading clients…</p>
                                            </div>
                                        )}

                                        {!isLoading && error && (
                                            <div className="alert alert-danger">{error}</div>
                                        )}

                                        {!isLoading && !error && (
                                            <>
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search by name, email or client code…"
                                                        value={search}
                                                        onChange={e => setSearch(e.target.value)}
                                                    />
                                                </div>
                                                <div style={{ maxHeight: 480, overflowY: "auto" }}>
                                                    {renderClients()}
                                                </div>
                                            </>
                                        )}

                                        <br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
            </Screen>
        </div>
    );
}

export default MRClientSelectPage;
